export enum BranchType {
    BR21,
    BR23
}
